import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Custom sizes and spacing from theme.css. Unregistered, a `text-*` it doesn't know reads as a colour,
// so `cn("text-card-subtitle", "text-subtle-foreground")` would drop one of the two.
const twMerge = extendTailwindMerge({
    extend: { theme: { text: ["card-title", "card-subtitle"], spacing: ["card-header-y", "card-header-row"] } },
});

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
